export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path
      d="M16 2C9.9 2 5 6.9 5 13c0 7.5 9.4 15.6 10.3 16.4a1 1 0 0 0 1.4 0C17.6 28.6 27 20.5 27 13 27 6.9 22.1 2 16 2Z"
      fill="#FF6B35"
    />
    <ellipse cx="16" cy="16.6" rx="3.4" ry="2.6" fill="#F9F8F6" />
    <ellipse cx="10.4" cy="11.8" rx="1.7" ry="2.2" fill="#F9F8F6" transform="rotate(-18 10.4 11.8)" />
    <ellipse cx="13.9" cy="9.3" rx="1.7" ry="2.2" fill="#F9F8F6" transform="rotate(-6 13.9 9.3)" />
    <ellipse cx="18.1" cy="9.3" rx="1.7" ry="2.2" fill="#F9F8F6" transform="rotate(6 18.1 9.3)" />
    <ellipse cx="21.6" cy="11.8" rx="1.7" ry="2.2" fill="#F9F8F6" transform="rotate(18 21.6 11.8)" />
  </svg>
);

export const Logo = ({ testId = "logo" }) => (
  <a
    href="#top"
    data-testid={testId}
    className="flex items-center gap-2.5 transition-transform duration-300 hover:scale-[1.03]"
  >
    <LogoMark />
    <span className="font-display font-bold text-xl tracking-tight text-[#1A1A1A]">
      Fuffy<span className="text-[#FF6B35]">Fam</span>
    </span>
  </a>
);
